import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <h2 className="footer-logo">Prosperian</h2>
          <p className="footer-description">
            Transformez votre prospection commerciale avec notre suite d'outils intelligents et notre expertise stratégique.
          </p>
        </div>

        <div className="footer-content">
          <div className="footer-column">
            <h3 className="footer-title">Navigation</h3>
            <ul className="footer-links">
              <li><Link to="/" className="footer-link">Accueil</Link></li>
              <li><Link to="/methode" className="footer-link">Méthode</Link></li>
              <li><Link to="/suite" className="footer-link">Suite</Link></li>
              <li><Link to="/etudes-de-cas" className="footer-link">Études de cas</Link></li>
              <li><Link to="/faq" className="footer-link">FAQ</Link></li>
              <li><Link to="/a-propos" className="footer-link">À propos</Link></li>
              <li>
                <a href="https://calendly.com/cb-prosperian/presentation-prosperian" target="_blank" rel="noopener noreferrer" className="footer-link">
                  Contactez-nous
                </a>
              </li>
              <li><Link to="/charte" className="footer-link">Charte</Link></li>
              <li><Link to="/client" className="footer-link">Accès Client</Link></li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Contact</h3>
            <ul className="footer-contact">
              <li className="footer-contact-item">
                <a href="mailto:contact@prosperian.co">contact@prosperian.co</a>
              </li>
              <li className="footer-contact-item">
                <a href="tel:+33123456789">+33 1 23 45 67 89</a>
              </li>
              <li className="footer-contact-item">
                42 rue Ampère,<br />75017 Paris, France
              </li>
            </ul>
          </div>

          <div className="footer-column">
            <h3 className="footer-title">Newsletter</h3>
            <p className="footer-newsletter-text">
              Restez informé des dernières actualités et tendances en prospection commerciale.
            </p>
            <form className="footer-form-group">
              <input type="email" className="footer-input" placeholder="Votre email" />
              <button type="submit" className="footer-button">S'abonner</button>
            </form>
          </div>
        </div>

        <div className="footer-suite">
          <h3 className="footer-suite-title">Notre Suite</h3>
          <div className="footer-suite-columns">
            <div className="footer-suite-column">
              <h4 className="footer-suite-category">LinkedIn</h4>
              <ul className="footer-suite-list">
                <li><Link to="/suite#prospection" className="footer-suite-link">Message</Link></li>
                <li><Link to="/suite#prospection" className="footer-suite-link">Audio Message</Link></li>
                <li><Link to="/suite#prospection" className="footer-suite-link">Video Message</Link></li>
                <li><Link to="/suite#prospection" className="footer-suite-link">Document Ads</Link></li>
              </ul>
            </div>
            <div className="footer-suite-column">
              <h4 className="footer-suite-category">Email</h4>
              <ul className="footer-suite-list">
                <li><Link to="/suite#prospection" className="footer-suite-link">Mail</Link></li>
                <li><Link to="/suite#prospection" className="footer-suite-link">Video Mail</Link></li>
              </ul>
            </div>
            <div className="footer-suite-column">
              <h4 className="footer-suite-category">Téléphone</h4>
              <ul className="footer-suite-list">
                <li><Link to="/suite#conversion" className="footer-suite-link">Agent IA Conversationnel</Link></li>
                <li><Link to="/suite#conversion" className="footer-suite-link">Prospection téléphonique</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-sectors">
          <h3 className="footer-sectors-title">Les Secteurs</h3>
          <div className="footer-sectors-columns">
            <div className="footer-sector-column">
              <h3 className="footer-sector-title">Services B2B</h3>
              <ul className="footer-sector-list">
                <li><Link to="/secteurs/conseil-formation" className="footer-sector-link">Conseil & Formation</Link></li>
                <li><Link to="/secteurs/recrutement" className="footer-sector-link">Recrutement</Link></li>
                <li><Link to="/secteurs/services-financiers" className="footer-sector-link">Services Financiers</Link></li>
                <li><Link to="/secteurs/agences" className="footer-sector-link">Agences</Link></li>
                <li><Link to="/secteurs/esn" className="footer-sector-link">ESN</Link></li>
              </ul>
            </div>

            <div className="footer-sector-column">
              <h3 className="footer-sector-title">Technologies</h3>
              <ul className="footer-sector-list">
                <li><Link to="/secteurs/editeurs-logiciels" className="footer-sector-link">Éditeurs de Logiciels</Link></li>
                <li><Link to="/secteurs/solutions-pro" className="footer-sector-link">Solutions professionnelles</Link></li>
                <li><Link to="/secteurs/technologie" className="footer-sector-link">Technologie</Link></li>
                <li><Link to="/secteurs/videosurveillance" className="footer-sector-link">Vidéosurveillance</Link></li>
              </ul>
            </div>

            <div className="footer-sector-column">
              <h3 className="footer-sector-title">Industrie & BTP</h3>
              <ul className="footer-sector-list">
                <li><Link to="/secteurs/industrie" className="footer-sector-link">Industrie</Link></li>
                <li><Link to="/secteurs/equipement" className="footer-sector-link">Équipement</Link></li>
                <li><Link to="/secteurs/btp" className="footer-sector-link">BTP</Link></li>
                <li><Link to="/secteurs/energies-renouvelables" className="footer-sector-link">Énergies Renouvelables</Link></li>
              </ul>
            </div>

            <div className="footer-sector-column">
              <h3 className="footer-sector-title">Services & Événementiel</h3>
              <ul className="footer-sector-list">
                <li><Link to="/secteurs/logistique" className="footer-sector-link">Logistique</Link></li>
                <li><Link to="/secteurs/transport" className="footer-sector-link">Transport</Link></li>
                <li><Link to="/secteurs/hotellerie" className="footer-sector-link">Hôtellerie</Link></li>
                <li><Link to="/secteurs/evenementiel" className="footer-sector-link">Événementiel</Link></li>
                <li><Link to="/secteurs/nettoyage" className="footer-sector-link">Nettoyage</Link></li>
                <li><Link to="/secteurs/rse" className="footer-sector-link">RSE</Link></li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-legal">
            <Link to="/mentions-legales" className="footer-legal-link">Mentions légales</Link>
            <Link to="/politique-confidentialite" className="footer-legal-link">Politique de confidentialité</Link>
            <Link to="/cookies" className="footer-legal-link">Politique relative aux cookies</Link>
          </div>
          <div className="footer-copyright">
            © 2025 Prosperian. Tous droits réservés.
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 